const initState = {
    user: null,
    error:{},
    edit: {
        status: 'success',
        code:''
    },
};
export default initState;
